import { AssignViewInfoDetails } from 'features/assigned-clients/components/assign-details/assign-view';
import { useParams } from 'react-router-dom';

export const AssignDetailsView = () => {
  const { id } = useParams();
  if (!id) return null;

  return <AssignViewInfoDetails Id={id} />;
};
